<dialog
    #dialog
    [attr.aria-labelledby]="titleId() || null"
    [attr.aria-describedby]="descriptionId() || null"
    (cancel)="onDialogCancel($event)">
    <button
        #closeButton
        type="button"
        class="sir-close-button"
        [attr.aria-label]="closeAriaLabel()"
        (click)="closeDialog()">
        <sirius-icon [name]="'x'"></sirius-icon>
    </button>
    <ng-content></ng-content>
</dialog>
